import React from 'react';
import CopyInHashButton from '../../Buttons/CopyInHashButton';
import {useGetUserRefQuery} from '../../../redux/userApi';
import {useTranslation} from 'react-i18next';
import {UserRefLink} from '../../../types/TypesUser';
import Loader from '../../../assets/Animations/PreLoaderComponent/Loader';
import s from './UserRefLinks.module.css';
import common from '../../../assets/common/CommonEffects.module.css';

interface Props {}

const UserRefLinks: React.FC<Props> = () => {
	const {t} = useTranslation();
	const {data: refData, isLoading} = useGetUserRefQuery();
	if (isLoading) return <Loader />;
	if (refData?.links) {
		return (
			<div className={s.pageReferal}>
				<div className={`${s.referal} ${common.cardContainerPadded}`}>
					<div className={s.referalTitle}>{t('Мої реферальні посилання')}</div>
					<div className={s.referalRow}>
						{refData?.links?.map((link: UserRefLink, index: number) => (
							<div key={index + link.type} className={s.referalColumn}>
								{link && <CopyInHashButton link={link} />}
							</div>
						))}
					</div>
				</div>
			</div>
		);
	} else return null;
};

export default UserRefLinks;
